export default __webpack_public_path__ + "static/goles-dd805460012f8fc458b11755bbd24494.svg";